import App from '../App.vue'

export var m_api_login = {
  methods: {
    api_login: function(username, password) {
      var that = this
      return new Promise(function(resolve, reject) {
        that.$api.get('login', { auth: {username: username, password: password }, headers: { 'X-APIReq-Type': 'login' } }).then(response => {
          // j = JSON.parse(response.data)
          if (!('token' in response.data)) {
            reject('Authentication token error')
            return
          }

          if (!('server_time' in response.data)) {
            reject('Server time record not found')
            return
          }

          that.$store.commit('set_server_time_delta',response.data.server_time)

          if (username != 'admin') {
            that.$store.commit('set_authtoken',response.data.token)

            that.$store.commit('set_ws_login_status',3)
            that.$socket.emit('login',that.$store.state.authtoken)
          }

          if (username === 'admin') {
            that.$api.get('/accountlist',{ headers: { 'X-Access-Token': response.data.token, 'X-APIReq-Type': 'login' } }).then(inner_response => {
              var acclist = []
              var branch_codes = {}
              inner_response.data.data.forEach(function(account) {
                if (account.account_id != 'admin') {
                  acclist.push(account.account_id)
                  branch_codes[account.account_id] = account.branch_code
                }
              })
              that.$store.commit('set_admin_acclist',acclist.sort())
              that.$store.commit('set_admin_branchcodes',branch_codes)
              that.$store.commit('set_authtoken',response.data.token)
              that.$store.commit('set_ws_login_status',3)
              that.$socket.emit('login',that.$store.state.authtoken)
            }).catch(e => {
              reject('Error loading account list.')
              return
            })
          } else {
            that.$store.commit('set_authtoken',response.data.token)
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    }
  }
}

export const api_interceptor_req_cfg = function(config) {
  // set activity so that the authentication token will be renewed if we are active
  if (config.headers['X-APIReq-Type'] != 'tokenrenew') {
    App.store.commit('set_activity')
  }

  // do not add custom headers for login request
  if (config.headers['X-APIReq-Type'] === 'login') {
    return config
  }

  config.headers['X-Access-Token'] = App.store.state.authtoken

  return config
}

export const api_interceptor_req_err = function(error) {
  return Promise.reject(error)
}

export const api_interceptor_resp_cfg = function(response) {
  return response
}

export const api_interceptor_resp_err = function(error) {
  if (error.response) {
    if (error.response.status === 401 && error.response.statusText === 'UNAUTHORIZED') {
      App.store.commit('set_authtoken',null)
    }
  }
  return Promise.reject(error)
}
